<template>
  <div class="outer-hg-100">
    <div class="info-content" ref="scrollContent" :style="{ height: divHeight + 'px' }">
      <div class="make-title">Make Your Test</div>
      <div class="test-name-row">
        <div class="test-name-col">
          <div class="test-name test-name-1">Test Name</div>
          <div class="mock-test-text">{{ stepOneData.testName }}</div>
        </div>
        <div class="test-name-col">
          <div class="test-name test-name-1">Target Exam</div>
          <div class="mock-test-text">
            {{ stepOneData.targetSelected.text }}
          </div>
        </div>
      </div>
      <div class="test-name">Subjects</div>
      <div class="card-panel">
        <div class="jee-user-row-cust" v-if="subjects && subjects.length">
          <div
            class="card-data"
            @click="toggleCheckbox(item)"
            :style="item.checked ? { border: '1px solid #089BE5' } : ''"
            v-for="(item, index) in subjects"
            :key="index"
          >
            <img
              :src="
                require('@/assets/img/myttargetexamicon/' + item.text + '.svg')
              "
              class="card-icon"
            />
            <div class="card-title" :class="item.text.toLowerCase()">
              {{ item.text }}
            </div>
            <v-checkbox
              v-model="item.checked"
              :value="item.id"
              color="secondary-darken-3"
              @change="getSelectedSubject(item)"
              @click.stop
            ></v-checkbox>
          </div>
        </div>
        <div v-else class="no-subject">
        <!-- <span class="no-subject2"> -->
        
          No subjects available for target exam {{ stepOneData.targetSelected.text }}
        <!-- </span> -->
        </div>
      </div>
      <div class="myt-dropdown add-ch-arrow practice-session-drop-outer"
      v-if="selectedSubjectWithDifficultyLevel && selectedSubjectWithDifficultyLevel.length"
>
        <div class="test-name test-top-20 scroll-difficulty">Difficulty</div>
        <div
          class="practice-session-drop-down"
        >
          <div
            class="field-data"
            v-for="(item, index) in selectedSubjectWithDifficultyLevel"
            :key="index"
          >
            <label>{{ item.text }}</label>
            <v-select
              v-model="item.difficulty"
              @change="onSelectDifficulty()"
              attach
              :menu-props="{ top: true, offsetY: true }"
              :items="difficultyLevels"
              item-text="title"
              item-value="id"
              hide-details
              dense
              outlined
              class="required fix-140-width"
              :class="item.difficulty ? 'selected-border-myt' : ''"
            >
            </v-select>
          </div>
        </div>
      </div>
      <div class="myt-dropdown selectedPatterns"  @click="onPatternSelect()"
      v-if="selectedSubjectWithDifficultyLevel && selectedSubjectWithDifficultyLevel.length && isAllDifficultySelected()"
      >
        <div class="test-name test-top-20 pattern-step-4 scroll-pattern">Pattern</div>
        <div class="input-radio-row">
          <v-radio-group
            v-model="selectedPatterns"
            class="input-radio-row-outer"
          >
            <div
              class="input-radio"
              @click="selectedPatterns=item.value.id"
              :class="
                selectedPatterns === item.value.id ? 'selected-border-myt' : ''
              "
              v-for="(item, index) in patterns"
              :key="index"
            >
              <!--v-text-field
                disabled
                v-model="item.text"
                dense
                outlined
                hide-details
                class="radio-input-bg"
                :value="item.text"
              ></v-text-field-->
              <div class="input-view">{{ item.text }}</div>
              <div class="radio-drop-myt">
                <v-radio
                  color="secondary-darken-3"
                  :value="item.value.id"
                ></v-radio>
              </div>
            </div>
            <div
              class="input-radio"
              @click="selectedPatterns='custom-pattern'"
              :class="
                selectedPatterns == 'custom-pattern'
                  ? 'selected-border-myt'
                  : ''
              "
            >
              <!--v-text-field
                disabled
                value="Custom Pattern"
                dense
                outlined
                hide-details
                class="radio-input-bg"
                >Custom Pattern</v-text-field
              -->
              <div class="input-view">Custom Pattern</div>
              <div class="radio-drop-myt">
                <v-radio
                  value="custom-pattern"
                  color="secondary-darken-3"
                ></v-radio>
              </div>
            </div>
          </v-radio-group>
        </div>
      </div>
    </div>
    <div class="footer-btn" v-if="selectedPatterns">
      <div></div>
      <div v-if="selectedPatterns === 'custom-pattern'">
        <v-btn
          color="primary"
          class="cust-btn myt-next"
          @click="
            onCustomizeClick({
              stepOneData: stepOneData,
              stepTwoData: {                selectedSubjects,
                selectedSubjectWithDifficultyLevel,
                ...getStepFourData(false)},
              
            })
          "
        >
          Next
        </v-btn>
      </div>
      <div class="step-two-btn" v-else>
        <v-btn
          color="primary"
          class="cust-btn myt-syllabus myt-other-button"
          @click="
            onCustomizeClick({
              stepOneData: stepOneData,
              stepTwoData: {                selectedSubjects,
                selectedSubjectWithDifficultyLevel,
                ...getStepFourData(true)},
              
            })
          "
        >
          Customize Syllabus
        </v-btn>
        <v-btn
          color="primary"
          class="cust-btn myt-other-button"
          @click="
            onNextClick({
              stepOneData: stepOneData,
              stepTwoData: {
                selectedSubjects,
                selectedSubjectWithDifficultyLevel,
                ...getStepFourData(false)
              },

            })
          "
        >
          Create Full Test
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import constants from "../../../../utils/constants";

export default {
  props: ["stepOneData", "data", "onNextClick",'onCustomizeClick','onClickDifficultyLevel','onCLickSubject','onClickPattern','step','patternData'],
  name: "StepTwoData",
  data() {
    return {
      e1: 1,
      selectedSubjects: [],
      selectedSubjectWithDifficultyLevel: [],
      subjects: [],
      difficultyLevels: constants.DIFFICULTY_LEVELS,
      patterns: [],
      selectedPatterns:null,
      elemHeight:null
    };
  },
  destroyed(){
    localStorage.removeItem('scrollPosition');
    window.removeEventListener("resize", this.updateDivHeight);
  },
  created(){
    window.addEventListener("resize", this.updateDivHeight);
  },
 computed:{
    divHeight() {
      this.updateDivHeight();
     return this.elemHeight 
    },
  },
  mounted() {
    if (this.data) {
      this.selectedSubjects = _.cloneDeep(this.data.selectedSubjects);
      let difficultyCheck = [];
      if (this.stepOneData) {
      if (this.stepOneData.targetSelected) {
        this.reqGetTestPattern();
      }
    }
    if (this.stepTwoData) {
      if (this.stepTwoData.subjects) {
        this.items = this.stepTwoData.subjects;
      }
      if (this.stepTwoData.selectedSubjectWithDifficultyLevel) {
        this.selectedSubjectWithDifficultyLevel = this.stepTwoData.selectedSubjectWithDifficultyLevel;
      }
      if (this.stepTwoData.selectedSubjects) {
        this.selectedSubjects = this.stepTwoData.selectedSubjects;
      }
    }
      // this.selectedSubjects = this.selectedSubjects.map((s) => {
      //   difficultyCheck.push(s);
      //   delete s.difficulty;
      //   delete s.sortBy;
      //   return s;
      // });
      this.selectedSubjectWithDifficultyLevel = this.data.selectedSubjectWithDifficultyLevel;
    }
    if (this.stepOneData) {
      if (this.stepOneData.targetSelected) {
        this.reqGetTestPattern();
      }
    }
    this.getSubjects();
    let scrollPosition = parseInt(localStorage.getItem('scrollPosition'));
    if(scrollPosition){
      this.restoreScrollPosition(scrollPosition);
    }else if((this.step== 3 || this.step== 4)){
        this.$nextTick(() => {
          if( window.innerWidth>991){
            this.$refs.scrollContent.scrollTop=this.$refs.scrollContent.scrollHeight;
          }
          else{
            let scrollElem= this.step==3 ? document.getElementsByClassName("scroll-difficulty") : document.getElementsByClassName("scroll-pattern");
            document.body.scrollTop = document.documentElement.scrollTop = scrollElem[0].offsetTop + 50;
          }
        });
    }
  },
  methods: {
    ...mapActions({
      getTestTarget: "utilStore/getTestTarget",
      getDataTreeWithLevelPublic: "utilStore/getDataTreeWithLevelPublic",
      getMYTTestPatterns: "utilStore/getMYTTestPatterns",

    }),
    toggleCheckbox(item) {
    item.checked = !item.checked;
    this.getSelectedSubject(item)
  },
   onPatternSelect(){
      this.saveScrollPosition();
      let stepOneData=this.stepOneData
      let selectedSubjects=this.selectedSubjects
      let selectedSubjectWithDifficultyLevel=this.selectedSubjectWithDifficultyLevel
      let getStepFourData=this.getStepFourData(false)

      this.onClickPattern(       {       stepOneData: stepOneData,
              stepTwoData: {                selectedSubjects,
                selectedSubjectWithDifficultyLevel,
                ...getStepFourData},
              
            });
   },
  onSelectDifficulty(){
       this.saveScrollPosition();
      let stepOneData=this.stepOneData
      let selectedSubjects=this.selectedSubjects
      let selectedSubjectWithDifficultyLevel=this.selectedSubjectWithDifficultyLevel
      let getStepFourData=this.getStepFourData(false)

      this.onClickDifficultyLevel(       {       stepOneData: stepOneData,
              stepTwoData: {                selectedSubjects,
                selectedSubjectWithDifficultyLevel,
                ...getStepFourData},
              
            });
   },
   updateDivHeight(){
     if (window.innerWidth > constants.MOBILE_MAX_WIDTH) {
        this.$nextTick(() => {
          this.elemHeight=  this.setDivHeight();
         });
      }
   },
   saveScrollPosition() {
     if(window.innerWidth>991){
       let scrollPosition = this.$refs.scrollContent.scrollTop;
       localStorage.setItem('scrollPosition', scrollPosition);
     }else{
       let scrollPosition = document.documentElement.scrollTop;
       localStorage.setItem('scrollPosition', scrollPosition);
     }
      
   },
   restoreScrollPosition(scrollPosition) {
       this.$nextTick(() => {
         if(window.innerWidth>991){
           this.$refs.scrollContent.scrollTop=scrollPosition;
         }else{
           document.documentElement.scrollTop=scrollPosition;
         }
        localStorage.removeItem('scrollPosition');
      });
   },
    getSelectedSubject(item) {
      this.saveScrollPosition();
      if (item.checked) {
        this.selectedSubjects.push(item);
      } else {
        let index =
          this.selectedSubjects &&
          this.selectedSubjects.length &&
          this.selectedSubjects.findIndex((x) => x.value.id === item.value.id);
        this.selectedSubjects &&
          this.selectedSubjects.length &&
          this.selectedSubjects.splice(index, 1);
      }
      this.onSelectSubject();
    },
    getSubjects() {
      this.selectedSubjectWithDifficultyLevel = [];
      this.subjects = [];
      if (
        this.data &&
        this.data.selectedSubjects &&
        this.data.selectedSubjects.length
      ) {
        this.selectedSubjects = this.data.selectedSubjects;
        this.selectedSubjectWithDifficultyLevel = this.data.selectedSubjectWithDifficultyLevel;
      } else {
        this.selectedSubjects = [];
      }
      let subjects = JSON.parse(this.stepOneData.targetSelected.subjects);
      subjects.map((x) => {
        let c = {};
        if (x.id === constants.BIOLOGY_SUBJECT_ID) {
          constants.BIOLOGY_SUBSUBJECTS.map((s) => {
            let sub = {};
            let index = this.selectedSubjects.findIndex(
              (ss) => ss.value.id == s.id
            );
            sub.text = s.title;
            sub.value = { ...s };
            sub.checked = index > -1;
            this.subjects.push(sub);
          });
        } else {
          let index = this.selectedSubjects.findIndex(
            (ss) => ss.value.id == x.id
          );
          c.text = x.title;
          c.value = { ...x };
          c.checked = index > -1;
          this.subjects.push(c);
        }
      });
    },
    onSelectSubject() {
      if (this.selectedSubjects && this.selectedSubjects.length > 0) {
        this.selectedSubjectWithDifficultyLevel = this.selectedSubjectWithDifficultyLevel.filter(
          (item) => {
            return !!this.selectedSubjects.find((s) => {
              return s.value.id == item.value.id;
            });
          }
        );
        this.selectedSubjects.map((item) => {
          const e = this.selectedSubjectWithDifficultyLevel.find((s) => {
            return s.value.id == item.value.id;
          });
          if (!e) {
            this.selectedSubjectWithDifficultyLevel.push(item);
          }
        });
      }else{
        this.selectedSubjectWithDifficultyLevel = []
      }
      let stepOneData=this.stepOneData
      let selectedSubjects=this.selectedSubjects
      let selectedSubjectWithDifficultyLevel=this.selectedSubjectWithDifficultyLevel
      let getStepFourData=this.getStepFourData(false)

      this.onCLickSubject(       {       stepOneData: stepOneData,
              stepTwoData: {                selectedSubjects,
                selectedSubjectWithDifficultyLevel,
                ...getStepFourData},
              
            });
    },
    reqGetTestPattern() {
      this.selectedPatterns = null;

      if (this.data && this.data.targetSelected) {
        this.selectedPatterns = this.data.targetSelected;
      }
      this.getMYTTestPatterns({
        test_target_id: this.stepOneData.targetSelected.value,
        myt_pattern: true
      })
        .then((response) => {
          this.loading = false;
          if(response && response.length<1){
            this.patternData.negative_marks=null;
            this.patternData.positive_marks=null;
          }
          this.patterns = response.map((x) => {
            let c = {};
            c.text = x.pattern_name;
            c.value = x;
            c.value.test_params = JSON.parse(c.value.test_params);
            c.checked = false;
            if(c.value && c.value.test_params){
              this.patternData.negative_marks=c.value.test_params[0].negative_marks;
              this.patternData.positive_marks=c.value.test_params[0].positive_marks;
              this.patternData.negative_marks=this.patternData.negative_marks < 0 ? -(this.patternData.negative_marks) : this.patternData.negative_marks;  
            }
            else{
              this.patternData.negative_marks=null;
              this.patternData.positive_marks=null;
            }
            return c;
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    isAllDifficultySelected(){
      let valid = true;
      this.selectedSubjectWithDifficultyLevel.map(s=>{
        if (!s.difficulty) {
          valid=false
        }
      })
      return valid;
    },
    getStepFourData(customize) {
      let selectedPatterns = this.patterns.find(
        (p) => p.value.id === this.selectedPatterns
      )?.value;
      return {
        selectedPatterns: selectedPatterns
          ? selectedPatterns
          : this.selectedPatterns,
        targetSelected: this.selectedPatterns,
        customize
      };
    },
    
  }
};
</script>